import React from "react";
import { toast } from "react-toastify";
// Common Components
import { TextInput, Button } from "src/Components";
import { CommonTableUI } from "src/Tables/TableTemplate/common";
import TableTemplate from "src/Tables/TableTemplate/tableTemplate";
import { getPortfolioGroupAdditional } from "./GroupModalAdditional";
// Services
import {
  getPortfolioGroupTable,
  upsertPortfolioGroup,
} from "src/Requests/portfolioGroups";
// Utilities
import { packetErrorHandler } from "src/Utils/requestUtils";
// Types
import {
  IPortfolioGroupTableReport,
  IPortfolioGroupSearchParams,
} from "src/Interfaces/portfolioGroups";

interface IProps {
  onSuccess: () => void;
}
const AddGroupModal: React.FC<IProps> = ({ onSuccess }) => {
  const [name, setName] = React.useState("");
  const [groupId, setGroupId] = React.useState<number | undefined>();
  const [loading, setLoading] = React.useState(false);
  const [refresh, setRefresh] = React.useState(false);

  const additional = React.useMemo(
    () =>
      getPortfolioGroupAdditional((row) => {
        setName(row.name ?? "");
        setGroupId(row.id);
      }),
    [],
  );

  React.useEffect(() => {
    if (refresh) setRefresh(false);
  }, [refresh]);

  return (
    <div>
      <div className="flex justify-start items-start gap-4 p-2 w-[300px]">
        <TextInput
          label="نام گروه"
          name="name"
          onChange={(_, value) => setName(value)}
          value={name}
        />
        <Button
          text="ثبت"
          onClick={() => {
            setLoading(true);
            upsertPortfolioGroup({ id: groupId, name })
              .then((resp) => {
                if (!resp.data) {
                  toast.error(resp.msg);
                  return;
                }
                toast.success(resp.msg || "با موفقیت ثبت شد");
                setName("");
                setGroupId(undefined);
                setRefresh(true);
                onSuccess();
              })
              .catch(packetErrorHandler)
              .finally(() => setLoading(false));
          }}
          variant="contained"
          className="!w-20"
          loading={loading}
        />
      </div>
      <div>
        <TableTemplate<IPortfolioGroupSearchParams, IPortfolioGroupTableReport>
          getDataTable={getPortfolioGroupTable}
          TableUI={({ reports, onAction }) => (
            <CommonTableUI
              reports={reports}
              onAction={onAction}
              AdditionalBody={additional}
              tableBoxClassName="!mx-0"
              refreshFlag={refresh}
            />
          )}
        />
      </div>
    </div>
  );
};

export default AddGroupModal;
